import { takeLatest, put, delay, call} from "redux-saga/effects";
import * as message from 'reducer/rMessageBox';

export function* sMessageBox(){
    yield takeLatest(message.fetchMessageBoxRequest, fetchMessageBox);
    yield takeLatest(message.fetchSuccessMessageBoxRequest, fetchSuccessMessageBox);
    yield takeLatest(message.fetchErrorMessageBoxRequest, fetchErrorMessageBox);
}

function* fetchMessageBox(action) {
    yield call(messageBoxOnOff, action.payload);
}

function* fetchSuccessMessageBox(action) {
    yield call(messageBoxOnOff, { isError: false, message: action.payload });
}

function* fetchErrorMessageBox(action) {
    yield call(messageBoxOnOff, { isError: true, message: action.payload });
}

function* messageBoxOnOff(data) {
    yield put(message.fetchMessageBoxOn(data))
    yield delay(3000)
    yield put(message.fetchMessageBoxOff())
}